import React, { memo, ReactNode } from 'react';

import './index.less';

import MarkdownContent from '../MarkdownContent';
import IbTypography from '../common/IbTypography';
import Avatar, { AvatarName } from '../common/Avatar';

const MAIN_CLASS_NAME = 'message-list-item';
const SELECTED_CLASS_NAME = `${MAIN_CLASS_NAME}_selected`;
const TITLE_CLASS_NAME = `${MAIN_CLASS_NAME}__title`;
const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;

export enum MessageListItemDirection {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}

export interface IMessageListItem {
  id: string;
  senderName: string;
  senderAvatar: string;
  content: string;
  isSelected: boolean;
  direction: MessageListItemDirection;
  contentPrefix?: ReactNode;
  contentSuffix?: ReactNode;
  titleSuffix?: ReactNode;
}

export interface IMessageListItemProps {
  message: IMessageListItem;
  onMessageSelect?: (message: IMessageListItem) => void;
}

const MessageListItem: React.FC<IMessageListItemProps> = ({ message, onMessageSelect }) => {
  const onMessageClick = () => onMessageSelect?.(message);

  const renderTitle = () => (
    <div className={TITLE_CLASS_NAME}>
      <Avatar avatarName={message.senderAvatar as AvatarName} />
      <IbTypography.Paragraph strong type="secondary">
        {message.senderName}
      </IbTypography.Paragraph>
      {message.titleSuffix}
    </div>
  );

  const renderContent = () => {
    if (message.content) {
      return (
        <div className={CONTENT_CLASS_NAME}>
          <MarkdownContent>{message.content}</MarkdownContent>
        </div>
      );
    }

    return null;
  };

  const mainClasses = [MAIN_CLASS_NAME, `${MAIN_CLASS_NAME}_${message.direction}`];
  if (message.isSelected) {
    mainClasses.push(SELECTED_CLASS_NAME);
  }

  return (
    <div className={mainClasses.join(' ')} onClick={onMessageClick}>
      {renderTitle()}
      {message.contentPrefix}
      {renderContent()}
      {message.contentSuffix}
    </div>
  );
};

export default memo(MessageListItem);
